import { LOCALES, LOCALE_LABELS, type Locale } from '@silospot/shared';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@silospot/ui';
import { Languages } from 'lucide-react';
import type { ReactElement } from 'react';
import { useChangeLocale } from '../lib/locale';
import { useLocaleStore } from '../stores/locale-store';

export function LanguageSelector(): ReactElement {
  const locale = useLocaleStore((state) => state.locale);
  const changeLocale = useChangeLocale();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2" aria-label="Change language">
          <Languages className="h-4 w-4" />
          <span className="hidden sm:inline">{LOCALE_LABELS[locale]}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LOCALES.map((value: Locale) => (
          <DropdownMenuItem
            key={value}
            onClick={() => changeLocale(value)}
            className={value === locale ? 'font-semibold' : undefined}
          >
            {LOCALE_LABELS[value]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
